const readResponsePayload = async (response) => {
  if (!response || typeof response.json !== "function") return {};
  return response.json().catch(() => ({}));
};

export const occupyTableWithLatestCycle = async ({
  requestOccupation,
  expectedCycle,
  allowCycleRetry = true,
}) => {
  const firstResponse = await requestOccupation(expectedCycle);
  const firstPayload = await readResponsePayload(firstResponse);

  if (firstResponse?.ok) {
    return {
      ok: true,
      payload: firstPayload,
      occupancyCycle:
        Number(firstPayload?.table?.occupancy_cycle) ||
        Number(expectedCycle) ||
        null,
      retried: false,
    };
  }

  const code = String(firstPayload?.code || "");
  const currentCycle = Number(firstPayload?.currentCycle);
  const currentStatus = String(firstPayload?.currentStatus || "").toLowerCase();
  const canRetry =
    allowCycleRetry &&
    ["TABLE_CYCLE_REQUIRED", "TABLE_CYCLE_CHANGED"].includes(code) &&
    currentStatus === "free" &&
    Number.isInteger(currentCycle) &&
    currentCycle > 0 &&
    currentCycle !== Number(expectedCycle);

  if (!canRetry) {
    return {
      ok: false,
      payload: firstPayload,
      occupancyCycle: currentCycle || Number(expectedCycle) || null,
      retried: false,
    };
  }

  const retryResponse = await requestOccupation(currentCycle);
  const retryPayload = await readResponsePayload(retryResponse);
  return {
    ok: Boolean(retryResponse?.ok),
    payload: retryPayload,
    occupancyCycle:
      Number(retryPayload?.table?.occupancy_cycle) ||
      Number(retryPayload?.currentCycle) ||
      currentCycle,
    retried: true,
  };
};
